export default "__VITE_ASSET__DdTxHIkR__"